/* Список голосов в чужой разметке: правая панель и лист «Другой голос».
   Родитель — пустой .tts-cat. Колонка с нужным id появляется из React, каркас ищет её по id. */
import { flushSync } from 'react-dom';
import { createRoot, type Root } from 'react-dom/client';
import { VoiceListBody } from './VoiceListBody';
import { createVoiceList, type VoiceListOpts, type VoiceListState } from './voice-list';

export interface VoiceSlot {
  state: VoiceListState;
  render(): void;
  refresh(delay?: number): void;
  destroy(): void;
}

/** Поставить список в пустой родитель (.tts-cat) */
export function mountVoiceSlot(parent: HTMLElement, id: string, opts: Omit<VoiceListOpts, 'el'>): VoiceSlot {
  parent.replaceChildren();
  const root: Root = createRoot(parent);
  const box: { list: ReturnType<typeof createVoiceList> | null } = { list: null };
  let alive = true;
  flushSync(() => {
    root.render(
      <VoiceListBody
        id={id}
        bind={commit => {
          const el = document.getElementById(id);
          if (!(el instanceof HTMLElement)) throw new Error('Список голосов: нет колонки #' + id);
          const list = createVoiceList({ ...opts, el }, commit);
          box.list = list;
          return () => {
            if (!alive) return;
            alive = false;
            list.destroy();
          };
        }}
      />,
    );
  });
  const slot = box.list;
  if (!slot) throw new Error('Список голосов: колонка #' + id + ' не собралась');
  return {
    get state() {
      return slot.state;
    },
    render() {
      slot.render();
    },
    refresh(delay = 0) {
      slot.refresh(delay);
    },
    destroy() {
      if (!alive) return;
      alive = false;
      slot.destroy();
      root.unmount();
    },
  };
}
